import { render } from "./tabella-notifiche.vue?vue&type=template&id=643e45da"
import script from "./tabella-notifiche.vue?vue&type=script&lang=js"
export * from "./tabella-notifiche.vue?vue&type=script&lang=js"

import "./tabella-notifiche.vue?vue&type=style&index=0&id=643e45da&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__